import { Progress, theme } from "antd";
import { useEffect, useState } from "react";

/**
 * Indeterminate progress bar for cross-route navigation.
 * Animates below 100% so the trail stays visible.
 */
export const TopProgressBar = () => {
  const { token } = theme.useToken();
  const [percent, setPercent] = useState(12);

  useEffect(() => {
    const interval = setInterval(() => {
      setPercent((current) => {
        if (current >= 88) {
          return 12;
        }
        return Math.min(current + 6 + Math.random() * 12, 88);
      });
    }, 220);

    return () => clearInterval(interval);
  }, []);

  return (
    <Progress
      percent={percent}
      status="active"
      showInfo={false}
      strokeLinecap="round"
      strokeColor={token.colorPrimary}
      trailColor={token.colorBorder}
      size={["100%", 4]}
      aria-label="Page loading"
    />
  );
};
